import { render } from "./PlantNotificationsForOrganisation.vue?vue&type=template&id=7caf13af"
import script from "./PlantNotificationsForOrganisation.vue?vue&type=script&lang=js"
export * from "./PlantNotificationsForOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__